module.exports = __webpack_public_path__ + "img/lepao.c8b357f9.png";